import styled from 'styled-components';
import { resetButton } from '../button';
import { bodySmall } from '../paragraph';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }): string => theme.spacing_unit_x1};
`;

export const Button = styled.button<{ selected: boolean }>`
  ${resetButton}
  ${bodySmall}

  background-color: ${({ theme, selected }): string =>
    selected === true ? theme.palette_blue_100 : theme.palette_gray_5};
  color: ${({ theme, selected }): string =>
    selected === true ? theme.palette_white : 'inherit'};
  border-radius: ${({ theme }): string => theme.border_radius_infinite};
  padding: ${({ theme }): string =>
    `${theme.spacing_unit_x1} ${theme.spacing_unit_x2}`};
  transition: all 250ms ease;
`;
